/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */
var $ = jQuery.noConflict();


document.addEventListener("DOMContentLoaded", function () {
    console.log('Setting portfolio');
    setPortfolio();
})

function setPortfolio() {
    jQuery(".portfolio-selector").each(function (i) {
      jQuery(this).data("index", i);
      if (i == 0) {
        jQuery(this).find(".line-auto").addClass("active").removeClass("inactive");
        jQuery(this).find(".circle").addClass("circle-active").removeClass("circle-inactive");
      }
    });
    jQuery(".portfolio-page").each(function (i) {
      jQuery(this).data("index", i);
      if (i == 0) {
        jQuery(this).addClass("active").removeClass("inactive");
        jQuery(this).find(".portfolio-thumb").addClass("active").removeClass("inactive");
        activePortfolioPage = i;
      }else{
        jQuery(this).find(".portfolio-thumb").addClass("inactive").removeClass("active");
      }
    });
  
    jQuery(".portfolio-selector").on("click", function (e) {
      const currIndex = jQuery(this).data("index");
      activePortfolioPage = currIndex;
      jQuery(".portfolio-image").addClass("inactive").removeClass("active");
      jQuery(".portfolio-selector").each(function (i) {
        if (jQuery(this).data("index") == currIndex) {
          jQuery(this).find(".line-auto").removeClass("inactive").addClass("active");
          jQuery(this).find(".circle").removeClass("circle-inactive").addClass("circle-active");

        } else {
          jQuery(this).find(".line-auto").removeClass("active").addClass("inactive");
          jQuery(this).find(".circle").removeClass("circle-active").addClass("circle-inactive");
        }
      });
      jQuery(".portfolio-page").each(function (i) {
        if (jQuery(this).data("index") == currIndex) {
          jQuery(this).addClass("active").removeClass("inactive");
          jQuery(this).find(".portfolio-thumb").addClass("active").removeClass("inactive");

        } else {
          jQuery(this).addClass("inactive").removeClass("active");
          jQuery(this).find(".portfolio-thumb").addClass("inactive").removeClass("active");
        }
      });
    });
    jQuery(".portfolio-thumb").on("click", function (e) {
      console.log("active:", activePortfolioPage);
      jQuery(".portfolio-page").removeClass("active").addClass("inactive");
      jQuery(".portfolio-image").addClass("active").removeClass("inactive");
      jQuery(".portfolio-image img").attr("src", e.currentTarget.src);
    });
    jQuery(".portfolio-image").on("click", function (e) {
      jQuery(".portfolio-image").addClass("inactive").removeClass("active");
      jQuery(".portfolio-page").each(function (i) {
        if (i == activePortfolioPage) {
          jQuery(this).removeClass("inactive").addClass("active");
        }
      });
    });
  }
  